<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                   <v-btn dark icon title="Back to Cutoff List" @click="$router.push('/company/timesheets')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn> 
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading" dark icon title="Print Reports" @click="showReportsMenu">
                        <v-icon>fa-solid fa-file</v-icon>
                    </v-btn>
                    <help-link appId="company" pageId="timesheets" color="white"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this timesheet.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="green" dark title="This period is already Closed. You will not be able to change this timesheet.">Closed</v-chip>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
            </v-card>
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="40">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search name, team" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <b>{{cutOffPeriod}}</b>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? headers_mobile: headers"
                    :items="time_reports_filtered"
                    :loading="loading" 
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr @click="viewUserTimesheet(props.item)" title="Click to view details, approve, reject" class="clickable">
                            <td>
                                <v-chip class="user-chip-container" small>
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <team-chips :teams="props.item.teams"></team-chips>
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                            </td>
                            <td v-if="!isMobile">
                                <span v-if="props.item.createdOn">{{ props.item.createdOn | moment('MMM DD, YYYY')}}</span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogReports" persistent width="670">
            <reports ref="reportsRef" :dialogReports.sync="dialogReports"></reports>
        </v-dialog>
    </v-layout>
</template>

<script>

import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, getSearchKeyword, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'

export default {
    name: 'AllTimesheets',
    metaInfo: {
        title: 'AllTimesheets',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View all company users timesheets then extract reports to excel.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'team-chips': () => import("@/components/Common/TeamsChip"),
        'help-link': () => import('@/components/Common/HelpLink'),
        'reports': () => import('@/components/Timesheet/TimesheetReports'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: getSearchKeyword(routeName),
            dialogReports: false,
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'30%', sortable:true},
                {text: 'Teams', align: 'left', value: 'firstName', width:'30%', sortable:true},
                {text: 'Timesheet Status', align: 'left', value: 'status', width: '20%', sortable:true},
                {text: 'Created On', align: 'left', value: '', width: '20%', sortable:false}
            ],
            headers_mobile: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'30%', sortable:true},
                {text: 'Teams', align: 'left', value: 'firstName', width:'30%', sortable:true},
                {text: 'Status', align: 'left', value: 'status', width: '40%', sortable:true},
            ],
            cutoff_details: [],
            time_reports: [],
            teams: []
        }
    },
    methods: {
        showReportsMenu() {
            var data = {
                selectedCutOffId: this.selectedCutOffId,
                selectedPeriod: this.cutOffPeriod,
                selectedTeamId: "0"
            }
            this.$refs.reportsRef.setParam(data)
            this.dialogReports=true
        },
        viewUserTimesheet(data) {
            this.$router.push(`${this.selectedCutOffId}/${data.userId}`)
        },
        async getCompanyTimeReports() {
            try {
                this.loading = true
                const response = await timesheetApi.getTimeReportByCompany(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.time_reports = response.data.items
                    this.cutoff_details = response.data.cutOffItem
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
          }
        },
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'All Employees Timesheets'
        })
        
        this.getCompanyTimeReports()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return getCutoffCoverageDescription(this.cutoff_details.cutoffStart, this.cutoff_details.cutoffEnd)
        },
        time_reports_filtered() {
            var temp = this.time_reports

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    const searchTerm = this.search.toLowerCase()
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchTerm)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchTerm)
                    const teamsMatch = item.teams.join(', ').toLowerCase().includes(searchTerm)

                    return firstNameMatch || lastNameMatch || teamsMatch
                })
            }
            return temp
        },
        frozenPeriod(){
            if (this.cutoff_details.status)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.cutoff_details.status)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
    }
}
</script>